import React from 'react';
import PropTypes from 'prop-types';

import NormalPlaceSearchFormField from '../../normal/PlaceSearchFormField';

const propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
    onSelect: PropTypes.func,
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
  }).isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onGettingCoord: PropTypes.func,
  onClearCoord: PropTypes.func,
  onFieldChange: PropTypes.func,
  onFieldBlur: PropTypes.func,
  enableEditing: PropTypes.any,
  additionalRestrictions: PropTypes.shape(),
  filterType: PropTypes.string,
};

const defaultProps = {
  onGettingCoord: () => {},
  onClearCoord: () => {},
  onFieldChange: () => {},
  onFieldBlur: () => {},
};

export const PlaceSearchFormField = props => {
  const {
    label,
    id,
    input: { value, onChange, onBlur, onFocus },
    meta: { error, touched, invalid },
    onGettingCoord,
    onClearCoord,
    onFieldChange,
    onFieldBlur,
    enableEditing,
    additionalRestrictions,
    filterType,
  } = props;

  const handleChange = newValue => {
    onChange(newValue);
    onFieldChange(newValue);
  };

  const handleBlur = () => {
    onBlur();
    onFieldBlur();
  };

  return (
    <NormalPlaceSearchFormField
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={onFocus}
      id={id}
      label={label}
      touched={touched}
      invalid={invalid}
      errMsg={error}
      onGettingCoord={onGettingCoord}
      onClearCoord={onClearCoord}
      disabled={enableEditing}
      additionalRestrictions={additionalRestrictions}
      filterType={filterType}
    />
  );
};

PlaceSearchFormField.propTypes = propTypes;
PlaceSearchFormField.defaultProps = defaultProps;

export default PlaceSearchFormField;
